/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'freccia': {
    width: 16,
    height: 18,
    viewBox: '0 0 16 18',
    data: '<g _stroke="#4A4A4A" _fill="none" fill-rule="evenodd"><path pid="0" d="M15.596 9.208h-15" _fill="#D8D8D8"/><path pid="1" d="M7.096 17l8.533-7.868L7.096 1"/></g>'
  }
})
